import { IMapHintService } from '../IMapHintService';

export const LOCAL_STORAGE_KEY = 'commercial-search-page-frontend.mapHintDisabled';

export class MapHintService implements IMapHintService {
  public setMapHintDisabledForUser(): void {
    localStorage.setItem(LOCAL_STORAGE_KEY, '1');
  }

  public getMapHintEnabledForUser(): boolean {
    const isDisabledForUser = localStorage.getItem(LOCAL_STORAGE_KEY);

    return !isDisabledForUser;
  }
}
